import { Button } from "antd";
import React from "react";

import "./ButtonComponent.css";
import { COLORS } from "../config/theme";

export default function ButtonComponent({
  toAction,
  color,
  icon,
  name,
  loading,
  disabled,
  className,
  type = "default",
}) {
  const getIcon = () => {
    return null;
  };

  const buttonColor = disabled ? COLORS.DISABLED : color || COLORS.SECONDARY;
  const textColor = disabled ? COLORS.DISABLED_TEXT : COLORS.TEXT;
  return (
    <Button
      className={`ButtonComponentStyle ${className}`}
      style={{ backgroundColor: buttonColor, color: textColor }}
      onClick={toAction}
      disabled={disabled}
      loading={loading}
      type={type}
    >
      {getIcon()}
      {name}
    </Button>
  );
}
